module.exports = __webpack_public_path__ + "static/media/loginImage.0291122c.png";